import type { SWRConfiguration } from 'swr'

export const swrConfig: SWRConfiguration = {
	revalidateOnFocus: false,
	revalidateOnReconnect: true,
	dedupingInterval: 10000,
	refreshInterval: 300000,
	errorRetryCount: 3,
	errorRetryInterval: 5000,
}
